import { useState, useEffect } from 'react';

// Web port of the app's ExpandingTextField (app/components/ExpandingTextField.jsx).
// Renders a normal inline textarea with a small expand affordance in the corner.
// Clicking it opens a large editor overlay so long descriptions can be written
// in a roomy box instead of a cramped 3-row field. Inline editing still works
// for quick tweaks; the same `value`/`onChange` drive both views.
const ExpandIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor"
    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <polyline points="15 3 21 3 21 9" />
    <polyline points="9 21 3 21 3 15" />
    <line x1="21" y1="3" x2="14" y2="10" />
    <line x1="3" y1="21" x2="10" y2="14" />
  </svg>
);

export default function ExpandingTextarea({
  value,
  onChange,
  placeholder,
  title = 'Edit',
  rows = 3,
  className = '',
  id,
}) {
  const [editing, setEditing] = useState(false);

  useEffect(() => {
    if (!editing) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') setEditing(false); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [editing]);

  return (
    <>
      <div className="expanding-textarea-wrap">
        <textarea
          id={id}
          className={className}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          rows={rows}
        />
        <button
          type="button"
          className="expanding-textarea-expand"
          onClick={() => setEditing(true)}
          aria-label={`Expand ${title.toLowerCase()} editor`}
          title="Expand"
        >
          <ExpandIcon />
        </button>
      </div>

      {editing && (
        <div
          className="modal-overlay expanding-editor-overlay"
          onMouseDown={(e) => { if (e.target === e.currentTarget) setEditing(false); }}
        >
          <div className="modal expanding-editor-modal" role="dialog" aria-modal="true" aria-label={title}>
            <div className="modal-header">
              <span className="event-modal-title">{title}</span>
              <button type="button" className="expanding-editor-done" onClick={() => setEditing(false)}>Done</button>
            </div>
            <div className="expanding-editor-body">
              <textarea
                className="expanding-editor-textarea"
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                autoFocus
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
}
